import React from "react";
import { styled } from "@mui/material";

const FooterContainer = styled("footer")({
  padding: "1rem",
  backgroundColor: "#bf1e55",
  color: "white",
  textAlign: "center",
  position: "fixed",
  left: 0,
  bottom: 0,
  width: "100%",
});

const FooterLink = styled("a")({
  color: "white",
  textDecoration: "none",
  margin: "0 0.5rem",
  "&:hover": {
    textDecoration: "underline",
  },
});

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <p>
        &copy;2025 Portland Dryer Mechanic LLC | 503-272-1113 |{" "}
        <FooterLink href="/about">About Us</FooterLink> |{" "}
        <FooterLink href="/contact">Contact</FooterLink>
      </p>
    </FooterContainer>
  );
};

export default Footer;
